import { join } from 'light-component';
import { Icons } from 'zf-web-components/icons';
import { Box } from '../../../box';
import { Block } from '../../../block';
import '../../styles/index.less';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { useBeforeColor, usePrimaryColor } from '../../hooks';
import { IconNamesMaps, Icon } from './icon';
import type { BlockProps } from './types';

export function BlockViewMode(props: BlockProps): React.ReactElement {
  const { rgbColor, hexColor } = usePrimaryColor();
  const className = 'widget-block';
  useBeforeColor(className, hexColor);

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={join(styles.viewBox, styles.viewBlock, 'block', className)}
      style={{ ...activeStyle, cursor: 'pointer' }}
      onClick={() => props.onWidgetChange('fold', props.name ?? '')}
    >
      <Box className={join(styles.subject, styles.block, 'block-subject')}>
        <Block if={Object.keys(IconNamesMaps).includes(props.blockIcon)}>
          <span className={styles.icon}>
            <Icon name={props.blockIcon} />
          </span>
        </Block>
        <Block if={!Object.keys(IconNamesMaps).includes(props.blockIcon)}>
          <Icons name='BlockIcon' className={styles.icon} />
        </Block>
        <Highlighter
          title={props.description}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
    </Box>
  );
}
